import { configureRequest } from "@asosteam/asos-web-request";
import searchConfig from "src/config/search";
import noticeError from "src/app/utilities/noticeError";
import logger from "src/app/utilities/logger";

const request = configureRequest({
  defaultTimeout: 10000,
  retries: 2,
  retryDelay: () => 500,
  logger,
  client: {
    name: "asos-contentweb-customer-care-help-pages",
    version: "1.0.0",
    platform: "CPT",
  },
});

export default async function fetchSearches(query, storeData, pageSize, index) {
  let response = null;
  const url = searchConfig.searchResultsApi;
  try {
    response = await request.get({
      url: `/api${url}search?q=${query}&store=${storeData.storeCode}&lang=${storeData.language}&country=${storeData.countryCode}&limit=${pageSize}&offset=${index}`,
    });
  } catch (err) {
    noticeError(err);
  }

  return response.data;
}
